export default __webpack_public_path__ + "static/media/EQ-IOM.1df1d222.pdf";